import {AsyncPipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {BillingService, Subscription} from '@app/admin/billing.service';
import {ClientService} from '@app/admin/client.service';
import {Observable} from 'rxjs';
import {map, mergeMap, startWith, tap} from 'rxjs/operators';

@Component({
    selector: 'frog-storage-dialog',
    templateUrl: './storage-dialog.component.html',
    styleUrls: ['./storage-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatFormField,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatAutocomplete,
        MatOption,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        AsyncPipe,
    ],
})
export class StorageDialogComponent implements OnInit {
    public storageControl: FormControl;
    public filteredOptions: Observable<string[]>;
    public subscription$: Observable<Subscription>;
    public storagePrice$: Observable<number>;
    public readonly unit = 50;
    private options: string[];

    constructor(
        private clientService: ClientService,
        private billingService: BillingService,
        public dialogRef: MatDialogRef<StorageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string,
    ) {
        this.storageControl = new FormControl(0);
        this.options = [];
        const count = 5000 / this.unit;
        for (let i = 0; i < count; i++) {
            this.options.push((i * this.unit).toString());
        }
    }

    ngOnInit(): void {
        this.filteredOptions = this.storageControl.valueChanges.pipe(
            startWith(this.unit.toString()),
            map((value) => this._filter(value)),
        );

        this.subscription$ = this.clientService.client.pipe(
            mergeMap((client) => this.billingService.getBillingInfo()),
            tap((subscription) => {
                const storageItems = subscription.items.filter(
                    (item) => item.product === '50GB Storage',
                );
                if (storageItems.length > 0) {
                    this.storageControl.setValue(storageItems[0].quantity * 50);
                }
            }),
        );

        this.storagePrice$ = this.subscription$.pipe(
            map((subscription) => {
                return subscription.storage_unit_amount;
            }),
        );
    }

    send() {
        const units = this.storageControl.value / 50;
        this.clientService.changeStorage(this.data, units).subscribe(() => {
            this.dialogRef.close(true);
        });
    }

    private _filter(value: string): string[] {
        return this.options.filter((option) => option.includes(value));
    }
}
